import styled from 'styled-components';
import WithDirection from '../../config/withDirection';


const SplitFormWrapper = styled.div`
`;

const OrderSummaryWrapper = styled.div`
.ant-tooltip-content { position: relative; }
          .ant-tooltip-inner {
            padding: 18px;
            padding-bottom: 21px;
            background-color: rgba(0, 0, 0, .65);
            line-height: 16px;
            font-family: 'Montserrat';
            font-size: 13px;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            letter-spacing: 0.04em;
            border-radius: 10px;
            text-shadow: 0 0 1px #555;
          }
          .ant-tooltip-placement-top .ant-tooltip-arrow {
            position: absolute;
            bottom: 0;\
            border-top-color: rgba(0, 0, 0, .4);
            transform: translateY(100%);
          }
    .sub-header {
        position: relative;
        margin: 0; margin-top: -1px;
        padding: 13px 0 36px 0;
        background-color: rgba(35, 31, 32, 1);
        line-height: 17px;
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 300;
        color: rgba(219, 219, 219, 1);
        text-align: center;
        letter-spacing: 0.08em;
        // -- .sub-header
    }
    .sub-header:after {
        position: absolute;
        right: 0; bottom: -3px; left: 0;
        display: inline-block;
        content: '';
        height: 3px;
        background-color: rgba(12,183,148,1);
        z-index: 1;
    }

    .main {
        margin: 0;
        padding: 0; padding-top: 44px; padding-bottom: 70px;
        background-color: rgba(243, 243, 243, 1);

        .info {
            margin: 0 auto;
            padding: 0;
            width: 100%;
            max-width: 893px;
            background-color: rgba(249, 249, 249, 1);

            > * { padding-right: 48px; padding-left: 64px ; }
            .app-header {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 38px;
                padding-top: 42px; padding-left: -25px;

                dt { width: 85px; height: 78px; }
                dt img { border-radius: 1rem; }

                dd {
                    .app-name,
                    .app-stores {
                        display: block;
                        padding-left: 11px;
                    }
                    .app-name {
                        font-family: 'Montserrat';
                        font-size: 22px;
                        font-weight: 300;
                        color: rgba(64, 55, 57, 1);
                        letter-spacing: 0.09em;
                    }
                    .app-stores {
                        margin-top: 8px;
                        max-width: 600px;
                        font-family: 'Roboto', sans-serif;
                        font-size: 14px;
                        color: rgba(147, 147, 147, 1);
                        text-align: justify;
                        letter-spacing: 0.04em;

                        img { margin-left: 7px; width: 24px; }
                    }
                }
                // -- .app-header
            }
                
            h2 {
                margin-top: 0; margin-bottom: 21px;
                line-height: 60px;
                font-weight: 700;
                font-family: 'Montserrat';
                font-size: 14px;
                color: rgba(64, 55, 57, 1);
                letter-spacing: 0.08em;
                background-color: rgba(252, 252, 252, 1);
                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);
                text-transform: uppercase;
            }

            .summary {
                table {
                    tbody {
                        border-bottom: 1px solid rgba(219, 219, 219, 1);
                        > tr:first-child th {
                            font-family: 'Montserrat';
                            font-size: 14px;
                            color: rgba(64, 55, 57, 1);
                            letter-spacing: 0.04em;
                            line-height: 15px;
                        }
                        > tr:first-child td {
                            font-family: 'Montserrat-Light';
                            font-size: 12px;
                            color: rgba(64, 55, 57, 1);
                            letter-spacing: 0.04em;
                            line-height: 15px;
                        }
                    }
                    
                    th, td { padding-bottom: 16px; }
                    th {
                        padding-right: 60px;
                        font-family: 'Montserrat';
                        font-size: 14px;
                        color: rgba(147, 147, 147, 1);
                        letter-spacing: 0.04em;
                        line-height: 15px;
                    }
                    td {
                        font-family: 'Montserrat-Light';
                        font-size: 12px;
                        color: rgba(147, 147, 147, 1);
                        letter-spacing: 0.04em;
                        line-height: 15px;

                        span { padding-left: 11px; font-size: 14px; font-family: 'Montserrat-Light'; }
                    }

                    tfoot {
                        th, td {
                            padding-top: 16px;
                            padding-bottom: 47px;
                            font-family: 'Montserrat';
                            color: rgba(64, 55, 57, 1);
                            letter-spacing: 0.04em;
                            line-height: 15px;
                        }
                        th, td span { font-size: 14px; font-weight: 700; }
                    }
                    // -- table
                }
                
                p {
                    margin-bottom: 57px;
                    font-family: 'Montserrat';
                    font-size: 14px;
                    color: rgba(12, 183, 148, 1);
                    letter-spacing: 0.04em;
                }
                // -- .summary
            }

            .promotion-code {
                padding-top: 18px; padding-bottom: 18px;
                background-color: rgba(219, 219, 219, 0.35);

                dl {
                    margin-top: 0; margin-bottom: 0;

                    dt {
                        font-family: 'Montserrat';
                        font-size: 14px;
                        color: rgba(64, 55, 57, 1);
                        letter-spacing: 0.04em;
                    }

                    .border-wrapper{
                        input:valid + .placeholder { display: none; }
                        input { margin-right: 31px; width: 220px; }
                        button {
                            margin-right: 5px; margin-left: 2px;
                            display: inline-block;
                            border-left: 1px solid rgba(151, 151, 151, 1);
                            width: 65px;
                            background-color: transparent;
                            font-family: 'Montserrat';
                            font-size: 14px;
                            color: rgba(64, 55, 57, 1);
                            text-align: center;
                            letter-spacing: 0.04em;
                            text-transform: uppercase;
                        }
                    }
                }
                // -- .promotion-code
            }

            .card-info {
                padding-bottom: 42px;

                dl + dl { margin-left: 44px; }
                dt {
                    display: flex;
                    align-items: flex-start;
                    line-height: 17px;
                    font-family: 'Montserrat';
                    font-size: 14px;
                    color: rgba(35, 31, 32, 1);
                    letter-spacing: 0.01em;
                }
                dl { margin-bottom: 0; }

                .card-number .border-wrapper input { margin-right: 70px; width: 155px; }
                .card-number img { margin-right: 21px; height: 10px; }
                .card-exp-date .border-wrapper input { margin-right: 51px; width: 60px; }
                .card-exp-date .placeholder { color: rgba(219, 219, 219, 1); }
                .card-cvc .border-wrapper input { margin-right: 0; width: 84px; }
                .card-cvc dt {
                    span {
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        margin-left: 7px;
                        border: 1px solid rgba(147, 147, 147, 1);
                        width: 14px; height: 14px;
                        font-family: 'Roboto', sans-serif;
                        font-size: 11px;
                        color: rgba(147, 147, 147, 1);
                        letter-spacing: 0.07em;
                        border-radius: 14px;
                    }
                }

                dl + p {
                    margin-top: 20px;
                    display: flex;
                    align-items: center;

                    img:not(:first-child) { margin-left: 25px; }
                }

                dl + p + p {
                    margin-top: 20px;
                    
                    * { display: inline-block; margin: 0; padding: 0; vertical-align: middle; }
                    label {
                        margin: 0;
                        margin-left: 10px;
                        font-family: 'Montserrat';
                        font-size: 12px;
                        font-weight: 300;
                        color: rgba(64, 55, 57, 1);
                        letter-spacing: 0.04em;
                    }
                }

                dl ~ button {
                    margin: 0; margin-top: 24px; margin-left: -18px;
                    background-color: rgba(60, 211, 207, 1);
                    padding: 10px 50px 10px 43px;
                    font-family: 'Montserrat';
                    font-size: 15px;
                    color: rgba(255, 255, 255, 1);
                    text-align: center;
                    letter-spacing: 0.01em;
                    border-radius: 20px;
                    
                    img {
                        height: 18px;
                        transform: rotate(90deg) translateY(-14px);
                        filter: brightness(0) invert(1);
                    }
                }
                // -- .card-info
            }
        }

        .info {
            dl {
                display: inline-block;

                .border-wrapper {
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    margin-top: 10px; margin-left: -12px;
                    border: 1px solid rgba(151, 151, 151, 1);
                    padding-left: 24px;
                    line-height: 40px;
                    border-radius: 20px;
                 
                    > * { margin: 0; padding: 0; }

                    input:focus, input:active { outline-width: 0; }
                    input[type=number]::-webkit-inner-spin-button, 
                    input[type=number]::-webkit-outer-spin-button { 
                        -webkit-appearance: none; 
                        margin: 0; 
                    }
                    input {
                        outline-width: 0;
                        border-width: 0;
                        min-width: none; min-width: auto; min-width: unset;
                        background-color: transparent;
                        z-index: 1; 
                    }
                    input.not-empty + .placeholder { opacity: 0; }
                    .placeholder {
                        position: absolute;
                        left: 24px;
                        font-family: 'Montserrat';
                        font-size: 14px;
                        color: rgba(147, 147, 147, 1);
                        letter-spacing: 0.04em;
                    }   
                }
            }

            .card-info {
                .remeber-card {
                    font-family: 'Montserrat-Light';
                    color: rgba(147,147,147,1);
                }
            }
        }

        @media screen and (max-width: 767px) {
            padding: 34px 16px 104px 16px;
            
            .info {
                > * { padding-right: 15px; padding-left: 16px ; }
                .app-header {
                    padding-top: 18px;
                    .app-stores span { display: block; }
                    .app-stores span ~ img { margin-left: 0; margin-right: 7px; }
                }
                .promotion-code dl, .card-info dl {
                    dt { text-indent: 2px; }
                    .border-wrapper {
                        margin-left: -8px;

                        input { max-width: 50vw; }
                        .placeholder { right: 72px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
                    }
                }
                .card-info {
                    dl:not(:first-child) { margin-top: 32px; }
                    dl:not(:last-of-type) { margin-left: 0; }
                    dl:last-of-type { margin-left: 41px; }

                    dl ~ button { margin-left: 36px; }
                }
            }
        }
        // -- .main
    }
`;
// export default WithDirection(OrderSummaryWrapper);
export default  OrderSummaryWrapper ;



// WEBPACK FOOTER //
// ./src/containers/OrderReview/style.js